var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageEdit = function SvgImageEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.33 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 22.692 9.696 5.173L.245 32zm8.899-16.38 9.97 5.723-7.657 13.336-.567-1.705-2.925-.301-.501-1.833-2.864-.102-.807-2.007-2.302.225zM13.69 0c.275-.007.543.055.784.193l7.06 4.054c.858.49 1.052 1.767.434 2.849l-.842 1.465-10.17-5.836.843-1.47C12.244.48 12.989.018 13.69 0"
  })));
};
export { SvgImageEdit as ReactComponent };
export default __webpack_public_path__ + "assets/ImageEdit.7ab21f306a47b7573c51ab43c0617602.svg";